module.exports = __webpack_public_path__ + "img/liveState.2247e6bd.png";